import { API } from "../instances"

export const getByItaCode = async (code) => {
    const response = await API().get(`lyra/distributor/getByCode/${code}`)
    return response.data.data[0]
}

// ** Ficha del IBO en Lyra.
//
// Es la fuente precisa de su identificación: razón social, representante legal, documento y
// correo registrado. La sesión guarda una versión reducida de estos datos, y para el acuerdo
// del cupo —donde se firma con ellos— no basta: no distingue si el IBO es persona natural o
// compañía, que es lo que decide qué va en cada casilla del documento.
//
// La respuesta viene envuelta en un array de un elemento, igual que getByItaCode.
export const getByUserId = async (userId) => {
    const response = await API().get(`lyra/distributor/getByUserId/${userId}`)
    return response.data.data?.[0] ?? null
}
